import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const Visibility = z.enum(["Hidden", "Visible"]);
export const VisibilityValue = Visibility;
export const VisibilityTokenData = tokenAliasOrValue(VisibilityValue);

export type Visibility = z.infer<typeof Visibility>;
export type VisibilityValue = z.infer<typeof VisibilityValue>;
export type VisibilityTokenData = z.infer<typeof VisibilityTokenData>;
